import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ResponseCountries  {
    _originalTypeClassName = "zERP.BO.ResponseCountries";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ResponseCountries.translate = translateService;
}
this.Countries = [];
this.ResponseCountriesKey = null;
this._key = this.ResponseCountriesKey = 0; 
}

static translate: TranslateService;
_key: any;
Countries:any;
private _ResponseCountriesKey:any;
get ResponseCountriesKey(): any {
    return this._ResponseCountriesKey;
  }
set ResponseCountriesKey(value: any) {
    this._ResponseCountriesKey = value;
    this._key = value;
  }
static setCountries = ($this, items) => {
                if (items == null) items = [];
                if ($this.Countries == null) $this.Countries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Countries.length > 0) {
                    Domain.ResponseCountries.removeCountries($this, $this.Countries[0]);
                }

                Domain.ResponseCountries.addManyCountries($this, copyItems);
            }
static addManyCountries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ResponseCountries.addCountries($this, items[i]);
                }
            }
static addCountries = ($this, item) => {
                if ($this.Countries == null) $this.Countries = [];
                if (item == null || $this.Countries.indexOf(item) > -1) return;
                $this.Countries.push(item);
}
static addRangeCountries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ResponseCountries.addCountries($this, item));
            }
static removeCountries = ($this, item) => {
                if ($this == null || $this.Countries == null || $this.Countries.indexOf(item) === -1) return;
                var _index = $this.Countries.indexOf(item);
                $this.Countries.splice(_index, 1);
}
static clearCountries = ($this) => { $this.Countries = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ResponseCountriesKey == null || $this.ResponseCountriesKey == 0;
            }


}